import {useContext} from "react";
import {AuthContextState, IAuthContext} from "../context/AuthContext";

export const useAuth = () => useContext<AuthContextState>(IAuthContext);
